import { render, staticRenderFns } from "./anunt-6.vue?vue&type=template&id=cc09dbf6&scoped=true"
import script from "./anunt-6.vue?vue&type=script&lang=js"
export * from "./anunt-6.vue?vue&type=script&lang=js"
import style0 from "./anunt-6.vue?vue&type=style&index=0&id=cc09dbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc09dbf6",
  null
  
)

export default component.exports